import {css} from '@emotion/react'
import {CompassOutlined} from '@ant-design/icons'

const Message = ({children}) => {
    return <p>{children}</p>
}

const NextStep = ({children}) => {
    if (! children) {
        return null
    }

    return (
        <p><CompassOutlined /> {children}</p>
    )
}

export const ResponseBodyOutOfScopeJson = ({message, ...props}) => {
    const {message: msg, nextStep} = JSON.parse(message.content)

    return (
        <div
            {...props}
        >
            <Message>{msg}</Message>
            <NextStep>{nextStep}</NextStep>
        </div>
    )
}
